import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labTopicNewRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/topics/new',
}).lazy(() => import('pages/lab/Topics/LabTopicNewPage/LabTopicNewPage').then((d) => d.Route));
